import React from 'react';
import { CircleCheckIcon } from 'lucide-react';
import { instantItems } from '../data/content';
export function InstantAccess() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-124" data-mp="2582nt2k0r622">
      <div className="mx-auto max-w-2xl" data-id="element-125" data-mp="1r9uhw5508uer">
        <h2 className="text-center font-serif text-[1.6rem] font-black leading-tight tracking-tight text-stone-900 sm:text-4xl" data-id="element-126" data-mp="1r8t4hu0invtv">
          <span aria-hidden="true" data-id="element-127" data-mp="1hj9l8n8w5zyh">📲 </span>¿Qué Recibes al Instante?
        </h2>

        <ul className="mt-10 space-y-3" data-id="element-128" data-mp="1hhgfrba0lls2">
          {instantItems.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-stone-100 px-5 py-4 text-sm font-medium text-stone-800" data-id="element-129" data-mp="1mbaz2dlpjyqm">
              <CircleCheckIcon className="h-4 w-4 shrink-0 text-red-600" aria-hidden="true" data-id="element-130" data-mp="1ckyfoopmqbm2" />
              {item}
            </li>)}
        </ul>

        <p className="mt-10 text-center font-serif text-lg font-bold italic text-red-600 sm:text-xl" data-id="element-131" data-mp="13i71wi9a73r9">
          Todo organizado en un solo sistema para que dejes de empezar cada
          clase desde cero.
        </p>
      </div>
    </section>;
}